import PagedElements from '@/models/paged/pagedelements';
import StoreTransferListViewInterface from '@/models/view/storetransferviewmodel';

export default class PagedStoreTransfers extends PagedElements<StoreTransferListViewInterface> {
    constructor(init?: Partial<PagedStoreTransfers>) { super(init); }
}
